export enum GtmExternal {
  VARIABLE_PAGENAME= 'PageName',
  VARIABLE_PAGEURL= 'PageURL',
  VARIABLE_PAGEPATH= 'PagePath',
  VARIABLE_USERID= 'UserId',
  EVENT_CONTENTCHANGE = 'ContentChange',
  EVENT_LOCATIONSELECTED = 'LocationSelected',
  EVENT_PLACEORDER = 'purchase',
  EVENT_CHECKOUT = 'begin_checkout',
  EVENT_FAVORITE = 'favorites',
  EVENT_SIGNIN_SUCCESS= 'signin_success',
  EVENT = 'event',
  EVENT_CTA_CLICK = 'cta_click',
  EVENT_ERROR = 'error',
  EVENT_DEVICE_LOCKED = 'device_locked',
  EVENT_NEW_DEVICE_SUCCESS = 'new_device_success',
  EVENT_NEW_DEVICE_ERROR = 'new_device_error',
  EVENT_CHECKOUT_OFFER = 'checkout_offer',
  VALUE_HOMEPAGE = 'Home',
  VALUE_STARTORDERING = 'StartNewOrder',
  VALUE_MENUPAGE = 'OrderMenu',
  VALUE_SELECTALOCATION = 'SelectALocation',
  VALUE_FINDAMENU = 'FindYourMenu',
  VALUE_CATEGORY = 'Category',
  VALUE_MYORDER = 'MyOrder',
  VALUE_CUSTOMIZATIONSCREEN1 = 'Customize1',
  VALUE_CUSTOMIZATIONSCREEN2 = 'Customize2',
  VALUE_CONTACTINFOPAGE = 'BeginCheckout',
  VALUE_ADDPAYMENTPAGE = 'AddPayment',
  VALUE_CONFIRMANDPAY = 'ConfirmAndPay',
  VALUE_SIGNIN = 'SignIn',
  VALUE_CAREERS = 'Careers',
  VALUE_HOME_AND_FIELD = 'Home and Field',
  VALUE_CAREERS_RESTAURANT = 'Restaurant',
  VALUE_CAREERS_FAQS = 'Career FAQs',
  VALUE_APPLY_FOR_SUPPORT = 'Community Apply For Support',
  VALUE_GROUP_DINING_START = 'Group Dining Start',
  VALUE_CONTACT_US = 'Contact Us',
  VALUE_CONTACT_US_TOPICS = 'Contact Us Topics',
  VALUE_CONTACT_US_LOCATIONS = 'Contact Us Locations',
  VALUE_CONTACT_US_EXPERIENCE = 'Contact Us Experience',
  VALUE_CONTACT_US_CONTACT_INFO = 'Contact Us Contact Info',
  VALUE_CONTACT_US_SUMMARY = 'Contact Us Summary',
  VALUE_CONTACT_US_THANKS = 'Contact Us Thanks',
  VALUE_CONTACT_US_COPORATE_INFO = 'Contact Us Corporate Info',
  VALUE_HOME_SIGNUP = 'Email List Signup',
  VALUE_BENEFITS = 'Benefits',
  VALUE_MOBILE_APP_FAQS = 'Mobile App FAQs',
  VALUE_COMPANY = 'Company',
  VALUE_PORTALS = 'Portals',
  VALUE_PRIVACY_POLICY = 'Privacy Policy',
  VALUE_TERMS_AND_CONDITIONS = 'Terms and Conditions',
  VALUE_ACCOUNT = 'Account',
  VALUE_PAYMENT_METHODS = 'Payment Methods',
  VALUE_MESSAGING = 'Messaging',
  VALUE_ACCOUNT_HISTORY = 'Account History',
  VALUE_SETTINGS = 'Settings',
  VALUE_NOTIFICATIONS = 'Manage Notifications',
  VALUE_EDIT_FAV_ORDER = 'Edit Favorite Order',
  VALUE_ADD_VISIT = 'Add a Visit',
  VALUE_ADD_VISIT_COMPLETE = 'Add a Visit Complete',
  VALUE_STATUS_CLICKADD = 'clickAdd',
  VALUE_STATUS_BEGINCHECKOUT = 'beginCheckout',
  VALUE_STATUS_FAVORITED = 'favorited',
  VALUE_CLICK_TEXT_SIGN_IN = 'Sign In',
  VALUE_CLICK_TEXT_SEND_CODE = 'Send code',
  VALUE_CLICK_TEXT_RESEND_CODE = 'Resend code',
  VALUE_MODAL_CODE_EXPIRED = 'Code expired',
  VALUE_MODAL_ACC_LOCK = '30 min sign in lock',
  VALUE_MODAL_WRONG_DEVICE = 'Code for wrong device',
  VALUE_MODAL_SUCCESS = 'Success',
  VALUE_MODAL_UNSUCCESS = 'Login Unsuccessful',
  VALUE_MODAL_INVALID = 'Invalid Code',
  VALUE_MODAL_SENDCODE = 'Send Code',
  VALUE_MODAL_NEWDEVICE_POPUP = 'New Device Modal',
}
export class Actionfield {
  id: string;
  affiliation = 'Order.Whataburger';
  revenue: string;
  tax: string;
}

export class Purchase {
  actionField: Actionfield;
}

export class Detail {
  price: string;
}

export class Ecommerce {
  purchase: Purchase;
  detail: Detail;
}

export class BaseGTMDTO {
  ecommerce: Ecommerce;
  event: string;
  userId: string;
  locationId: string;
  longitude: string;
  latitude: string;
  payment_system?: PaymentTypeGTM;
  payment_type?: string;
}

export class FavoriteGTMDto extends BaseGTMDTO {
  status: string;
}
export class PageTrackingGtmDto {

  pageName: string;
  pagePath: string;
  pageUrl: string;
  event: string;
  userId: string;
  locationId: string;
  longitude: string;
  latitude: string;
  ecommerce: Ecommerce;

}

export class ModalTrackingGtmDto {

  pageName: string;
  pagePath: string;
  pageUrl: string;
  event: string;
  userId: string;
  modal: string;
  clickText: string;
}

export class VisitNudgeDto {
  event: string;
  screenName: string;
  current_card_value: number;
  modal: string;
}

export class PaymentCTAEvent {
    event: string;
    click_text?: string; // Text on CTA
    payment_system?: PaymentTypeGTM; // Payment system used
    payment_type?: string; // 'Credit/Debit Card {cardtype}' // Payment type used
    
}
export enum PaymentTypeGTM {
  Chase = 'Chase',
  Stripe = 'Stripe'
}
export interface Item {
  item_name: string;
  item_id: string;
  price: number;
  item_category: string;
  item_category2: string;
  item_category3: string;
  item_variant: string;
  index?: number;
  quantity: number;
  // Below are for Order only
  currency?: string;
  item_list_name?: string;
  locationid?: string;
}

export interface ECommerceItemArray {
  items: Item[];
}

export interface CartGTM {
  event: string;
  add_method?: string;
  item_list_name?: string;
  ecommerce?: ECommerceItemArray;
}
export const ReciptTypeNames: {[key: number]: string} = {
  1: 'A La Carte',
  2: 'Medium Meal',
  3: 'Small Meal',
  4: 'Breakfast',
  5: 'Kids Meal',
  6: 'Bundle'
}

export interface OrderEcommerce {
  transaction_id?: string;
  affiliation?: string;
  value: string;
  tax?: string;
  shipping?: string;
  currency: string;
  coupon: string;
  pickup_method?: string;
  order_method?: string;
  locationid?: string;  
  is_customized?: boolean;
  items?: Item[];
  payment_type?: string;
}

export interface OrderGTM {
  event: string;
  ecommerce: OrderEcommerce;
}
